import strings from 'strings';

export const COPIES = strings.ai.generators.roleplay;

export const FORM_FIELDS_MAP = {
  Specialty: { key: 'specialty' },
  Subspecialty: { key: 'subspecialty' },
  Title: { key: 'title' },
  Experience: { key: 'experience' },
  Difficulty: { key: 'difficulty' }
};

export const CALL_GOALS = [
  COPIES.scenarios.callCandidate.goals.confirmWilligness,
  COPIES.scenarios.callCandidate.goals.gatherInformation
];
